import type React from 'react';
import Translation from '../../../general/Translation/Translation';
import Button from '../../../../stories/Atoms/Button/Button';
import Dialog from '../../../../stories/Molecules/Dialog/Dialog';

export interface DeleteModalProps {
  onAccept: () => void;
  onClose: () => void;
}

const DeleteModal: React.FC<DeleteModalProps> = ({ onAccept, onClose }) => (
  <Dialog
    size="sm"
    onClose={onClose}
    open
    centered
  >
    <Dialog.Body>
      <div className="p-2">
        <p>
          <Translation
            pageString="winkelmand_teksten"
            stringId="remove_product_dialog"
          />
        </p>
        <Button
          primary
          fluid
          className="mt-6"
          onClick={onAccept}
        >
          <Translation
            pageString="winkelmand_teksten"
            stringId="remove_product_dialog_confirm"
          />
        </Button>
        <Button
          fluid
          className="mt-4"
          onClick={onClose}
        >
          <Translation
            pageString="winkelmand_teksten"
            stringId="remove_product_dialog_cancel"
          />
        </Button>
      </div>
    </Dialog.Body>
  </Dialog>
);

export default DeleteModal;
